var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.951,
    cy: 3.46996,
    r: 1.93706,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.577012
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.02824,
    cy: 3.84892,
    r: 2.60454,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02535 6.1759V6.1759C5.15307 7.2197 6.89417 7.2197 8.02189 6.1759V6.1759V6.1759C10.1044 7.02914 11.4647 9.05647 11.4647 11.307V14.5316V14.5316C8.06648 15.9906 4.22433 16.0218 0.80289 14.6182L0.591919 14.5316V11.2983C0.591919 9.05265 1.94812 7.02929 4.02535 6.1759V6.1759Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6546 5.45837C12.691 6.35029 11.2032 6.35029 10.2396 5.45837C9.7986 5.63954 9.39566 5.88241 9.03906 6.17456C10.8189 7.13417 11.9511 9.00156 11.9511 11.0547V13.553C13.5329 13.5532 15.1141 13.2348 16.5965 12.5983V9.84289C16.5965 7.91981 15.4341 6.18746 13.6546 5.45837Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.fadaaa9a9698e5018e727d66242ec634.svg";
export { ForwardRef as ReactComponent };